<template>
    <div class='input-cnt'>
        <div class='sub-line'>
            <div class='com-radio'>
                <input :id="id+'-1'" v-model='data' :name='id' :value='true' checked type='radio' />
                <label :for="id+'-1'">종합소득세 3.3%제외 합니다.</label>
            </div>
        </div>
        <div class='sub-line'>
            <div class='com-radio'>
                <input :id="id+'-2'" v-model='data' :name='id' :value='false' type='radio' />
                <label :for="id+'-2'">종합소득세를 제외 하지 않습니다.</label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingEmployeeSalaryTax',
    props: ['value', 'id'],
    data() {
        return {
            data: false,
        };
    },
    created() {

        this.data = this.value;
    },
    watch: {
        value(v){
            this.data = v;
        }
        ,
        data(v) {
            this.$emit('input', v);
        },
    },
};
</script>
